import { createCaptchaWindowWithPlaque } from '/request/captcha/captcha.js';
import {API_GATEWAY_NOSLASH} from '/constants/API_constants.js';
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";

export function createRequestObject() {
    const hiddenVariables = {
        rootUrl : null,
        url : null,
        searchParams : {},
        method : null,
        headers : {},
        body : null,
        processIfCaptchaRequired : true
    }

    const statusFunctions = {}

    const requestObject = {};
    
    statusFunctions['captcha'] = () => responseStatusFunctionCaptcha(requestObject);

    requestObject.setURL = (url) => setURL(hiddenVariables, url, requestObject);
    requestObject.setRootURL = (url) => setRootURL(hiddenVariables, url, requestObject);
    requestObject.addSearchParam = (paramName, paramValue) => addSearchParam(hiddenVariables, paramName, paramValue, requestObject);
    requestObject.setMethod = (method) => setMethod(hiddenVariables, method, requestObject);
    requestObject.addHeader = (headerName, headerValue) => addHeader(hiddenVariables, headerName, headerValue, requestObject);
    requestObject.setBodyJsonFromObject = (objectToAdd) => setBodyJsonFromObject(hiddenVariables, objectToAdd, requestObject);
    requestObject.setBodyFormData = (formData) => setBodyFormData(hiddenVariables, formData, requestObject);
    requestObject.executeRequest = () => executeRequest(hiddenVariables, statusFunctions);
    requestObject.onResponseStatus = (responseStatus, callback) => onResponseStatus(statusFunctions, responseStatus, callback, requestObject);
    
    for(let i=1; i<=5; i++) {
        requestObject[`onResponseStatus${i}xx`] = (callback) => onResponsexxx(statusFunctions, i, callback, requestObject);
    }
    requestObject.onResponseElse = (callback) => onResponseElse(statusFunctions, callback, requestObject);
    requestObject.onResponseError = (callback) => onResponseError(statusFunctions, callback, requestObject);

    return requestObject;
}

function setURL(hiddenVariables, url, requestObject) {
    hiddenVariables.url = url;
    
    return requestObject;
}

function setRootURL(hiddenVariables, rootUrl, requestObject) {
    hiddenVariables.rootUrl = rootUrl;
    if(hiddenVariables.url===null || hiddenVariables.url===undefined)
        hiddenVariables.url = "";

    return requestObject;
}

function addSearchParam(hiddenVariables, paramName, paramValue, requestObject) {
    hiddenVariables.searchParams[paramName] = paramValue;

    return requestObject;
}

function setMethod(hiddenVariables, method, requestObject) {
    hiddenVariables.method = method;

    return requestObject;
}

function addHeader(hiddenVariables, headerName, headerValue, requestObject) {
    hiddenVariables.headers[headerName] = headerValue;

    return requestObject;
}

function setBodyJsonFromObject(hiddenVariables, objectToAdd, requestObject) {
    hiddenVariables.body = JSON.stringify(objectToAdd);

    hiddenVariables.headers['Content-Type'] = "application/json";

    return requestObject;
}

function setBodyFormData(hiddenVariables, formData, requestObject) {
    hiddenVariables.body = formData;

    return requestObject;
}

async function executeRequest(hiddenVariables, statusFunctions) {
    const requestInfo = {
        method : hiddenVariables.method
    };

    if(hiddenVariables.rootUrl===null || hiddenVariables.rootUrl===undefined)
        hiddenVariables.rootUrl = API_GATEWAY_NOSLASH;
    

    const url = new URL(hiddenVariables.rootUrl + hiddenVariables.url);

    const searchParams = hiddenVariables.searchParams;

    if(searchParams!==null) {
        for(const [paramName, paramValue] of Object.entries(searchParams)) {
            url.searchParams.append(paramName, paramValue);
        }
    }

    /*
    const awsCaptchaToken = checkCaptchaToken();
    if(awsCaptchaToken!==null)
        addHeader(hiddenVariables, 'x-amzn-waf-captcha-token', awsCaptchaToken, null);
    */

    if(Object.entries(hiddenVariables.headers).length>0)
        requestInfo.headers = hiddenVariables.headers;

    console.log("request headers: ", requestInfo.headers);
    

    const body = hiddenVariables.body;
    if(body!==null && body!==undefined)
        requestInfo.body = body;
    

    try {
        const response = await fetch(url, requestInfo);
    
        const responseStatusFunctionCaptcha = statusFunctions['captcha'];
        const responseStatusFunction = statusFunctions[response.status];
        const responseStatusFunctionFTypeDefault = statusFunctions[getStatusFirstNumber(response.status)]; //for 1xx, 2xx, 3xx, etc.
        const responseStatusFunctionElse = statusFunctions['else'];
        
    
        if(response.headers.get("x-amzn-waf-action") === "captcha" && hiddenVariables.processIfCaptchaRequired === true) {
            return responseStatusFunctionCaptcha();
        } else if(responseStatusFunction!==null && responseStatusFunction!==undefined) {
            return responseStatusFunction(response);
        } else if (responseStatusFunctionFTypeDefault!==null && responseStatusFunctionFTypeDefault!==undefined) {
            return responseStatusFunctionFTypeDefault(response);
        } else if(responseStatusFunctionElse!==null && responseStatusFunctionElse!==undefined) {
            return responseStatusFunctionElse(response);
        }
    } catch (error) {
        const responseStatusError = statusFunctions['error'];

        if(responseStatusError!==null && responseStatusError!==undefined)
            responseStatusError();
        else
            throw error;
    }
}

function onResponseStatus(statusFunctions, responseStatus, callback, requestObject) {
    if(!(callback instanceof Function))
        throw new Error(`${callback} is not a function!`);

    statusFunctions[responseStatus] = callback;

    return requestObject;
}

function onResponsexxx(statusFunctions, number, callback, requestObject) {
    if(!(callback instanceof Function))
        throw new Error(`${callback} is not a function!`);

    statusFunctions[`${number}xx`] = callback;

    return requestObject;
}

function onResponseElse(statusFunctions, callback, requestObject) {
    if(!(callback instanceof Function))
        throw new Error(`${callback} is not a function!`);

    statusFunctions['else'] = callback;

    return requestObject;
}

function onResponseError(statusFunctions, callback, requestObject) {
    if(!(callback instanceof Function))
        throw new Error(`${callback} is not a function!`);

    statusFunctions['error'] = callback;

    return requestObject;

}

function getStatusFirstNumber(status) {
    const firstDigit = Math.floor(status / 100);
    return `${firstDigit}xx`;

}

async function responseStatusFunctionCaptcha(requestObject) {
    let resolver, rejecter;

    // Define the promise first
    const captchaPromise = new Promise((resolve, reject) => {
        resolver = resolve;
        rejecter = reject;
    });
    const CaptchaWindowOnPlaque = await createCaptchaWindowWithPlaque(
        async (captchaToken) => {

            console.log("Captcha check: retry function ", captchaToken);
            

            const captchaTokenObject = {
                captchaTokenValue : captchaToken,
                expiry: Date.now() + 5 * 60 * 1000
            }
            localStorage.setItem('aws_captcha_token', JSON.stringify(captchaTokenObject));

            const retryResponse = await requestObject.executeRequest();
            resolver(retryResponse);
        },
        (err) => {
            rejecter(err);
            console.log("Captcha error", err);     
        }
    )

    return captchaPromise;

}

function checkCaptchaToken() {
    const raw = localStorage.getItem('aws_captcha_token');
    if(!raw) return null;

    try{
        const captchaTokenObject = JSON.parse(raw);

        if(captchaTokenObject!==null && captchaTokenObject!==undefined) {
    
            if(Date.now() < captchaTokenObject.expiry) {
                return captchaTokenObject.captchaTokenValue;
            } else {
                localStorage.removeItem('aws_captcha_token');
                return null;
            }
        }

    } catch (err) {
        console.error("Invalid captcha token in storage", err);
        localStorage.removeItem('aws_captcha_token');
        return null;
    }
}